import { SxStyles } from 'types';

export const wrapper: SxStyles = {
  position: 'relative',
  display: 'flex',
  gap: '8px',
};
